// While the Jarvis works on an action: a capsule at the top with the core turning and glowing; then "Kész ✓" or the error.
import { useEffect, useState } from 'react';
import { onBusy } from './api';

export function JarvisSpinner({ size = 22 }: { size?: number }) {
  return <span className="j-spin" style={{ width: size, height: size }}><img src="/img/hud-orb.webp" alt="" /></span>;
}

export function BusyLayer() {
  const [n, setN] = useState(0);
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState<{ text: string; err: boolean } | null>(null);
  useEffect(() => onBusy((e) => {
    if ('busy' in e) setN(e.busy);
    if ('done' in e) setMsg({ text: 'Kész', err: false });
    if ('error' in e) setMsg({ text: e.error, err: true });
  }), []);
  // the capsule only after 150 ms (quick answers do not flicker)
  useEffect(() => { if (!n) { setShow(false); return; } const t = setTimeout(() => setShow(true), 150); return () => clearTimeout(t); }, [n]);
  useEffect(() => { if (!msg) return; const t = setTimeout(() => setMsg(null), msg.err ? 4000 : 1300); return () => clearTimeout(t); }, [msg]);
  useEffect(() => { document.body.classList.toggle('is-busy', n > 0); }, [n]);
  if (n > 0 && show) return <div className="busy-cap" role="status"><JarvisSpinner /> <span>Jarvis dolgozik…</span></div>;
  if (msg && n === 0) return <div className={`busy-cap ${msg.err ? 'err' : 'ok'}`} role="status">{msg.err ? '⚠ ' : '✓ '}{msg.text}</div>;
  return null;
}
